import { STORAGE_KEYS } from '@/shared/constants/storageKeys';

const hasLS = typeof window !== 'undefined' && !!window.localStorage;

const mem = new Map<string, string>();

function getItem(key: string): string | null {
  if (!hasLS) return mem.get(key) ?? null;
  return localStorage.getItem(key);
}
function setItem(key: string, val: string) {
  if (!hasLS) mem.set(key, val);
  else localStorage.setItem(key, val);
}
function removeItem(key: string) {
  if (!hasLS) mem.delete(key);
  else localStorage.removeItem(key);
}

export function setLastOrderContext(params: {
  orderId: number | string;
  restaurantId: number | string;
}) {
  setItem(STORAGE_KEYS.lastOrderId, String(params.orderId));
  setItem(STORAGE_KEYS.lastRestaurantId, String(params.restaurantId));
}

export function getLastOrderId(): string | null {
  return getItem(STORAGE_KEYS.lastOrderId);
}
export function getLastRestaurantId(): string | null {
  return getItem(STORAGE_KEYS.lastRestaurantId);
}

export function clearLastOrderContext() {
  removeItem(STORAGE_KEYS.lastOrderId);
  removeItem(STORAGE_KEYS.lastRestaurantId);
}

export function flagOpenCartOnNextLoad() {
  setItem(STORAGE_KEYS.openCartOnNextLoad, '1');
}
export function consumeOpenCartFlag(): boolean {
  const v = getItem(STORAGE_KEYS.openCartOnNextLoad);
  if (v) removeItem(STORAGE_KEYS.openCartOnNextLoad);
  return v === '1';
}
